var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex"},_vm._l((_vm.paneList),function(item,index){return _c('div',{key:index,staticClass:"pb-20 mr-50 paneText",class:_vm.openSearchFlag == item.name ? 'pitchOn' : 'NopitchOn',on:{"click":function($event){return _vm.changeTab(item.label)}}},[_vm._v(" "+_vm._s(item.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }